<template>
  <div
    class="section-head"
    :class="{ 'is-light': light }"
  >
    <!-- anneau dégradé > disque blanc > picto teinté en CSS (masque) : le picto
         livré est noir, il prend la couleur de la charte quel que soit le fichier -->
    <span class="section-head__icon">
      <span
        class="section-head__glyph"
        :style="{ '--icon': `url(${JSON.stringify(icon)})` }"
      />
    </span>
    <h2 class="section-head__title">{{ title }}</h2>
  </div>
</template>

<script>
export default {
  name: 'SectionHead',
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    light: {
      type: Boolean,
      default: false
    }
  }
}
</script>
